import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';
import { Operation, AuditDetails } from 'data/types';
import { UtimacoCircuitSwitch } from 'data/utimacoCircuitSwitch/utimacoCircuitSwitch.types';

// eslint-disable-next-line import/prefer-default-export
export function getAuditDetailsToSubmit(
  data: UtimacoCircuitSwitch,
  originaldata: UtimacoCircuitSwitch | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): AuditDetails {

  const auditDetails = getAuditDetails(
    isAuditEnabled,
    userId,
    userName,
    getAuditFieldInfo(data, null, false, originaldata),
    data.ISDN,
    AuditService.UTIMACO_PACKET_SWITCH,
    AuditActionType.UTIMACO_CIRCUIT_SWITCH_ADD,
  );
  return auditDetails as AuditDetails;
}
